import { render, staticRenderFns } from "./actStage.vue?vue&type=template&id=25a8efbc&scoped=true&"
import script from "./actStage.vue?vue&type=script&lang=js&"
export * from "./actStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a8efbc",
  null
  
)

export default component.exports